import { Component } from 'react';
import { createPortal } from 'react-dom';
export class Portal extends Component {
    constructor(props) {
        super(props);
        this.isAppended = false;
        this.el = document.createElement('div');
        // Use unique ID to prevent conflicts when multiple portals exist
        this.el.id = `portal-${Math.random().toString(36).substring(2, 11)}`;
        if (props.className) {
            this.el.className = props.className;
        }
    }
    componentDidMount() {
        var _a;
        try {
            (_a = document.body) === null || _a === void 0 ? void 0 : _a.appendChild(this.el);
            this.isAppended = true;
        }
        catch (e) {
            this.isAppended = false;
            console.error('Failed to append portal element:', e);
        }
    }
    componentWillUnmount() {
        try {
            // Only remove if we successfully appended and it's still a child
            if (this.isAppended && this.el && this.el.parentNode === document.body) {
                document.body.removeChild(this.el);
            }
            this.isAppended = false;
        }
        catch (e) {
            console.log(e);
            if (this.props.onException && typeof this.props.onException === 'function') {
                this.props.onException(e);
            }
        }
    }
    render() {
        const { children } = this.props;
        if (!children) {
            return null;
        }
        // @ts-ignore
        return createPortal(children, this.el);
    }
}
export default Portal;
